import { Injectable } from '@angular/core';
import { TurtleService } from './turtle.service';
import { BlocksService } from '../services/blocks.service';
import { LanguageService } from '../services/language.service';

import * as $ from 'jquery';
import { ColorService } from './color.service';

//##################################################################################
//
// This service is used to keep track of all information about the navigation tasks
// 
//##################################################################################

declare var swal: any;
declare var exerciseData: any;

@Injectable()
export class GridService {

    constructor(
        private turtleService: TurtleService,
        private blocks: BlocksService,
        private la: LanguageService) { }

    private isExerciseMode: boolean;
    private iconTurtleVariable = 'app/img/turtles/turtle0.png';
    private task;
    private taskData;
    private turtle;
    private turtleData;
    private chapterIndex: number;
    private currentIndex: number;
    private currentValueNumber: number;
    private currentValueString: string;
    private executionFinishedValue: boolean;
    private showSuccessPopup: boolean;

    exerciseModeActive() {
        return this.isExerciseMode;
    }

    quitExerciseMode() {
        // Hide the exercise environment and return to standard environment 
        this.isExerciseMode = false;
        $("#canvasT").show();
        $("#canvasD").show();
        $("#titleWrapper").hide();
    }

    openExercise(task, iconTurtleVariable, clearHistory: boolean, chapterIndex?: number, currentIndex?: number) {
        // Switch to exerciseMode and hide the standard turtle
        this.isExerciseMode = true;
        $("#canvasT").hide();
        $("#canvasD").hide();

        // Set the turtle image
        this.iconTurtleVariable = iconTurtleVariable;

        // Empty containers and make space for new exercise
        $("#exerciseArea").empty();
        $("#wrapperEatenObjects").empty();
        $("#drawArea").empty();

        // Set indices and show buttons
        this.chapterIndex = chapterIndex;
        this.currentIndex = currentIndex;
        $(".btn-prev").show();
        $(".btn-next").show();
        $(".btn-next").css("background-color", "");


        // Logic for 'next' and 'prev' buttons
        if (chapterIndex == null || currentIndex == null) {
            // Hide the buttons if the exercise is not from the textbook
            $(".btn-next").hide();
            $(".btn-prev").hide();
        } else if (currentIndex >= exerciseData[chapterIndex].tasks.length - 1 && exerciseData[chapterIndex + 1] == null) {
            // Hide the 'next' button if we reached the end of the chapter, and there's no subsequent chapter
            $(".btn-next").hide();
        } else if (currentIndex == 0 && exerciseData[chapterIndex - 1] == null) {
            // Hide the 'prev' button if we are at the beginning of the chapter but there's no previous chapter
            $(".btn-prev").hide();
        }

        // Clear command history
        if (clearHistory) {
            this.blocks.clearHistory();
        }

        // Load exercise and set pencolor to default value
        this.loadExercise(task, iconTurtleVariable);
        this.turtleService.setPenColor(new ColorService('black'));
    }

    // If working with the textbook tasks, this function opens the subsequent task
    nextExercise() {
        let nextTask;
        let indexNextTask: number;
        let chapterIndexNextTask: number;

        // Check if we reached the end of the chapter
        if (this.currentIndex >= exerciseData[this.chapterIndex].tasks.length - 1) {
            if (exerciseData[this.chapterIndex + 1] != null) {
                // End of the chapter reached, continue with first task from next chapter
                indexNextTask = 0;
                nextTask = exerciseData[this.chapterIndex + 1].tasks[indexNextTask];
                chapterIndexNextTask = this.chapterIndex + 1;
                this.currentIndex = indexNextTask;
            } else {
                // End of the chapter reached, no subsequent chapter
                return;
            }
        } else {
            // End of the chapter not reached, continue with the next task from same chapter
            indexNextTask = this.currentIndex + 1;
            nextTask = exerciseData[this.chapterIndex].tasks[indexNextTask];
            chapterIndexNextTask = this.chapterIndex;
        }

        // Open the next task
        this.openExercise(nextTask, this.iconTurtleVariable, true, chapterIndexNextTask, indexNextTask);
        this.setTitle(nextTask.id);
    }

    // If working with the textbook tasks, this function opens the previous task
    prevExercise() {
        let prevTask;
        let indexPrevTask: number;
        let chapterIndexPrevTask: number;

        // Check if we are at the beginning of a new chapter
        if (this.currentIndex == 0) {
            if (exerciseData[this.chapterIndex - 1] != null) {
                // Continue with the last task of the previous chapter
                indexPrevTask = exerciseData[this.chapterIndex - 1].tasks.length - 1;
                prevTask = exerciseData[this.chapterIndex - 1].tasks[indexPrevTask];
                chapterIndexPrevTask = this.chapterIndex - 1;
                this.currentIndex = indexPrevTask;
            } else {
                // First task of the chapter, but there's no previous chapter
                return;
            }
        } else {
            // Not at the beginning of a new chapter, continue with the previous task from same chapter
            indexPrevTask = this.currentIndex - 1;
            prevTask = exerciseData[this.chapterIndex].tasks[indexPrevTask];
            chapterIndexPrevTask = this.chapterIndex;
        }

        // Open the next task
        this.openExercise(prevTask, this.iconTurtleVariable, true, chapterIndexPrevTask, indexPrevTask);
        this.setTitle(prevTask.id);
    }

    setTitle(title: string) {
        // Set the exercise title
        let titleWrapper = $("#titleWrapper");
        titleWrapper.show();
        // Only prepend "Exercise " if the given task is one from the textbook
        if (this.task.chapter != null)
            title = this.la.getLang()['exercise'] + " " + title+": "+this.la.getLang()['task.'+this.task.id];
        $("#exerciseTitle").text(title);
    }

    loadExercise(task, iconTurtleVariable) {
        // Load data
        this.task = Object.assign({}, task);
        this.taskData = Object.assign({}, task);
        let tiles = this.task.tiles;
        let specialObjects = this.task.specialObjects;
        this.currentValueNumber = 0;
        this.currentValueString = "";
        this.executionFinishedValue = false;
        this.showSuccessPopup = false;

        let paragraph = $("#wrapperSidebar").find("p");
        paragraph.text(this.la.getLang()['eatenObjects']);

        // Create the turtle, place it at the correct location
        let turtle = document.createElement("div");
        turtle.setAttribute("id", "exerciseModeTurtle");
        document.getElementById("exerciseArea").appendChild(turtle);
        turtle.style.top = (this.task.turtleData.positionVertical * 100) + "px";
        turtle.style.left = (this.task.turtleData.positionHorizontal * 100) + "px";
        turtle.style.backgroundImage = "URL(" + "./" + iconTurtleVariable + ")";
        turtle.style.backgroundSize = "60px 60px";
        this.turtle = turtle;
        this.turtleData = Object.assign({}, task.turtleData);
        // Set direction of turtle
        this.turtleService.setDirection(this.task.turtleData.direction);
        this.turn(this.task.turtleData.direction);

        let exerciseArea = document.getElementById("exerciseArea");
        // Default grid size is 3x3, this variable keeps track of the height the exerciseArea must have
        let heightOfParent = 300;

        // Draw all boxes
        tiles.forEach(function (element) {
            let box = document.createElement("div");
            box.classList.add("box");
            // Adjust height if needed
            if (element.positionVertical * 100 + 100 > heightOfParent)
                heightOfParent = element.positionVertical * 100 + 100;
            // Position the newly created box
            box.style.left = (element.positionHorizontal * 100) + 'px';
            box.style.top = (element.positionVertical * 100) + 'px';
            // Draw walls
            if (element.walls.top) {
                let wall = document.createElement("div");
                wall.classList.add("wallHorizontal");
                wall.style.left = (element.positionHorizontal * 100) + 'px';
                wall.style.top = (element.positionVertical * 100 - 2) + 'px';
                exerciseArea.appendChild(wall);
            }
            if (element.walls.left) {
                let wall = document.createElement("div");
                wall.classList.add("wallVertical");
                wall.style.left = (element.positionHorizontal * 100 - 2) + 'px';
                wall.style.top = (element.positionVertical * 100) + 'px';
                exerciseArea.appendChild(wall);
            }
            // Mark the box grey if it is a forbidden field
            if (!element.isAllowed) {
                box.style.backgroundColor = "grey";
            }
            // Append the box to the exerciseArea
            exerciseArea.appendChild(box);
        });

        //Adapts the height of the exerciseArea dynamically according to the lowest element
        $(exerciseArea).css("height", heightOfParent + 100 + 'px');
        $("#drawArea").css("height", heightOfParent + 100 + 'px');

        // Draw the specialObjects
        specialObjects.forEach(function (element) {
            let specialObj = document.createElement("div");
            specialObj.classList.add("specialObject");
            specialObj.style.left = (element.positionHorizontal * 100) + 'px';
            specialObj.style.top = (element.positionVertical * 100) + 'px';
            let specialObjectId = element.id;
            if (element.id == "character") {
                specialObj.innerHTML = element.value;
            } else {
                specialObj.style.backgroundImage = "URL(./app/img/specialObjects/" + specialObjectId + ".png)";
            }
            document.getElementById("exerciseArea").appendChild(specialObj);
            element.dom = specialObj;
        });
    }

    // Hook which is called when the 'lt' or 'rt' command is executed
    turn(direction?) {
        let dir = direction != null ? direction : this.turtleService.getDirection();
        document.getElementById("exerciseModeTurtle").style.transform = "rotate(" + dir + "deg)";
    }

    // Hook which is called when the 'fd' or 'bk' command is executed
    movefd(distance: number) {
        let madeMistake = false;
        // Get positive value of direction, modulo 360 
        let dir = this.translateAndGetDirection();
        // Get tile on which the turtle is curretly located 
        let currentTile = this.findTiles(this.turtleData.positionVertical, this.turtleData.positionHorizontal);

        // Coordinates used to draw the turtle stroke
        let x = this.turtleData.positionHorizontal;
        let y = this.turtleData.positionVertical;

        // Update position in turtleData and check if there is a wall in the direction we are facing
        // checkDirection() returns true if we hit a wall
        switch (dir) {
            case 0: {
                if (distance > 0) {
                    madeMistake = this.checkDirection(-1, 0, currentTile.walls.top);
                } else {
                    madeMistake = this.checkDirection(1, 0, currentTile.walls.bottom);
                }
                break;
            }
            case 90: {
                if (distance > 0) {
                    madeMistake = this.checkDirection(0, 1, currentTile.walls.right);
                }
                else {
                    madeMistake = this.checkDirection(0, -1, currentTile.walls.left);
                }
                break;
            }
            case 180: {
                if (distance > 0) {
                    madeMistake = this.checkDirection(1, 0, currentTile.walls.bottom);
                }
                else {
                    madeMistake = this.checkDirection(-1, 0, currentTile.walls.top);
                }
                break;
            }
            case 270: {
                if (distance > 0) {
                    madeMistake = this.checkDirection(0, -1, currentTile.walls.left);
                }
                else {
                    madeMistake = this.checkDirection(0, 1, currentTile.walls.right);
                }
                break;
            }
        }

        // Update position of visible turtle
        this.turtle.style.top = (this.turtleData.positionVertical * 100) + 'px';
        this.turtle.style.left = (this.turtleData.positionHorizontal * 100) + 'px';

        //Draw the turtle stroke
        this.drawLine(x, y, this.turtleData.positionHorizontal, this.turtleData.positionVertical);

        //Check if the turtle stepped on a special object and draw special object to the sidebar
        let specialObj = this.findSpecialObj(this.turtleData.positionVertical, this.turtleData.positionHorizontal);
        if (specialObj != null) {
            setTimeout(function () { specialObj.dom.remove() }, 350);
            this.task.specialObjects = this.task.specialObjects.filter(obj => obj !== specialObj);
            this.drawSpecialObjectsToSideBar(specialObj);
            if(specialObj.forbiddenElement) {
                this.resetTurtle(this.la.getLang()['forbiddenField']);
                return;
            }
            if(this.task.goal != null) {
                switch (typeof specialObj.value) {
                    case "number": {
                        this.currentValueNumber += specialObj.value;
                        if (this.currentValueNumber == this.task.goal) this.successPopup();
                    }
                    case "string": {
                        if (this.task.goal.type == "collect") {
                            let elementType = this.task.goal.elements;
                            if (elementType == specialObj.value && 
                                this.task.specialObjects.find(element => element.value == elementType) == null) {
                                    this.successPopup();
                                }
                        } else if (this.task.goal.type == "concat") {
                            let solution = this.task.goal.solution;
                            this.currentValueString += specialObj.value;
                            if (this.currentValueString == solution) {
                                this.successPopup();
                            }
                        }
                    }
                }
            }
        }

        //Check if the turtle stepped on a forbidden field and reset the turtle's position
        let nextTile = this.findTiles(this.turtleData.positionVertical, this.turtleData.positionHorizontal);
        if (nextTile == null) {
            this.resetTurtle(this.la.getLang()['leaveGrid']);
            return;
        } else if (!nextTile.isAllowed) {
            this.resetTurtle(this.la.getLang()['forbiddenField']);
            return;
        }

        // Check if we correctly solved the exercise
        // Note: For most exercises from the textbook it is not possible to set currentTile.success to a meaningful value 
        // If 'success' is not set, the following is ignored
        currentTile = this.findTiles(this.turtleData.positionVertical, this.turtleData.positionHorizontal);
        if (!madeMistake && currentTile.success && this.executionFinishedValue) {
            this.successPopup();
        } else if (!madeMistake && currentTile.success && !this.executionFinishedValue) {
            this.showSuccessPopup = true;
        }
    }

    executionFinished() {
        if (this.task.solution != null) {
            let solution = this.task.solution.replace(/ /g, '');
            let command = this.blocks.getCommand().replace(/ /g, '');
            if (solution === command) {
                this.successPopup();
            }
        }
        this.executionFinishedValue = true;
        if (this.showSuccessPopup) {
            this.successPopup();
        }
    }

    successPopup() {
        setTimeout(function () {
            swal({
                imageUrl: './app/img/reactions/solved.png',
                title: this.la.getLang()['congratulations'],
                text: this.la.getLang()['exSolved']
            });
            // Change the color of the 'next' button for more visual feedback
            $(".btn-next").css("background-color", "green");
        }.bind(this), 600);
    }

    // Function to update the turtle position and check if the turtle ran into a wall
    checkDirection(verticalChange: number, horizontalChange: number, wall: boolean) {
        this.turtleData.positionVertical += verticalChange;
        this.turtleData.positionHorizontal += horizontalChange;

        if (wall) {
            this.resetTurtle(this.la.getLang()['runIntoWall']);
            return true;
        }
        // return false if no mistake was made
        return false;
    }

    // Return the current direction modulo 360
    translateAndGetDirection() {
        return this.mod(this.turtleService.getDirection(), 360);
    }

    // Return special objects on the given tile
    findSpecialObj(positionVertical: number, positionHorizontal: number) {
        return this.task.specialObjects.find(element =>
            Math.trunc(element.positionVertical) == positionVertical && 
            Math.trunc(element.positionHorizontal) == positionHorizontal);
    }

    // Return tile with the given position
    findTiles(positionVertical: number, positionHorizontal: number) {
        return this.task.tiles.find(element =>
            element.positionVertical == positionVertical && element.positionHorizontal == positionHorizontal);
    }

    // Draw the turtlestroke
    drawLine(x1: number, y1: number, x2: number, y2: number) {
        $(document.createElementNS('http://www.w3.org/2000/svg', 'line')).attr({
            class: "draw",
            stroke: this.turtleService.getPenColor().getColorString(),
            "stroke-width": this.turtleService.getPenWidth() + 1,
            x1: x1 * 100 + 50,
            y1: y1 * 100 + 50,
            x2: x2 * 100 + 50,
            y2: y2 * 100 + 50
        }).appendTo("#drawArea");
    }

    // Draw the eaten objects to the sidebar
    drawSpecialObjectsToSideBar(element) {
        let specialObj = document.createElement("div");
        specialObj.classList.add("specialObjectSidebar");
        if (element.id == "character") {
            specialObj.innerHTML = element.value;
        } else {
            specialObj.style.backgroundImage = "URL(./app/img/specialObjects/" + element.id + ".png)";
        }
        setTimeout(function () { document.getElementById("wrapperEatenObjects").appendChild(specialObj); }, 350);
    }

    // Reset the turtle after a mistake was made
    resetTurtle(message: String) {
        // Stop execution of the remaining commands after a mistake
        let stopButton = document.getElementById("stopExec");
        stopButton.click();
        setTimeout(function () {
            swal({
                imageUrl: './app/img/reactions/wrong.png',
                title: 'Hoppla...',
                text: message
            })
            // Re-open the current exercise
            this.openExercise(this.taskData, this.iconTurtleVariable, false, this.chapterIndex, this.currentIndex);
            //call "eraser button" (disable history)
            this.blocks.colorHistoryGray();
            this.setTitle(this.task.id);
        }.bind(this), 600);
    }

    // Reset the whole task
    resetTask() {
        this.turtleService.setDirection(this.taskData.turtleData.direction);
        this.openExercise(this.taskData, this.iconTurtleVariable, false, this.chapterIndex, this.currentIndex);
    }

    // Hook which is called when the user changes the turtle image
    changeTurtleImage(newTurtle) {
        $("#exerciseModeTurtle").css("background-image", "URL(" + "app/img/turtles/" + newTurtle + ".png)");
    }


    // Helper function to compute modulo operations correctly
    mod(n: number, m: number) {
        return ((n % m) + m) % m;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/grid.service.ts